module.exports = __webpack_public_path__ + "3fe3fbd4177e9cee893d544156951f2f.pdf";